import { style } from '@vanilla-extract/css';

export const container = style({
  width: '100%',
  height: 'auto',
  padding: '16px',
});
